import React, { useEffect } from 'react';
import { Radio } from '@spark';
import {
    EMPTY_TRAJECTORIES_DEFAULT,
    emptyTrajectoryOptions,
    emptyTrajectorySectionCopy,
} from '@/features/datasets/utils/emptyTrajectoriesHandling';
import { HelpIcon } from '../shared/TaskTypeControls';

/**
 * Data Collection empty-trajectory choice for agentic tasks whose data
 * already contains trajectories. Mirrors EmptyResponsesSection (same FieldRow
 * markup and individually controlled Spark radios so each option keeps its
 * description line).
 *
 * Shown only when a trajectory column is mapped and the file may contain
 * empty trajectory cells (parent gates visibility).
 */
const EmptyTrajectoriesSection = ({ value, onChange, titleSuffix = '' }) => {
    const options = emptyTrajectoryOptions();
    const allowedValues = options.map((opt) => opt.value);
    const selectedValue = allowedValues.includes(value) ? value : EMPTY_TRAJECTORIES_DEFAULT;
    const copy = emptyTrajectorySectionCopy();
    const suffix = titleSuffix ? ` ${titleSuffix}` : '';
    const groupName = `empty-trajectories${titleSuffix || ''}`;

    useEffect(() => {
        if (!allowedValues.includes(value)) {
            onChange(EMPTY_TRAJECTORIES_DEFAULT);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    return (
        <div className="cw-dc-field-row" data-testid="empty-trajectories-section">
            <div className="cw-dc-field-row__label">
                <h3 className="cw-dc-section-title cw-dc-section-title--with-help">
                    <span>
                        {copy.title}
                        {suffix}
                    </span>
                    <HelpIcon text={copy.tooltip} />
                </h3>
                <p className="cw-dc-field-row__desc">{copy.description}</p>
            </div>
            <div className="cw-dc-field-row__controls">
                <div className="cw-dc-empty-responses" role="radiogroup" aria-label={copy.title}>
                    {options.map((opt) => (
                        <div key={opt.value} className="cw-dc-empty-responses__option">
                            <Radio
                                name={groupName}
                                value={opt.value}
                                label={opt.title}
                                status={selectedValue === opt.value ? 'active' : 'inactive'}
                                onChange={() => onChange(opt.value)}
                            />
                            <p className="cw-dc-empty-responses__option-desc">{opt.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default EmptyTrajectoriesSection;
